import { makeStyles } from '@mui/styles';

export const sharedStyles = makeStyles(() => ({
  container: {
    margin: 'auto',
  },
  paper: {
    borderRadius: '8px',
    maxWidth: '343px',
  },
  XPadding: {
    paddingLeft: '16px',
    paddingRight: '16px',
    paddingTop: '24px',
    paddingBottom: '24px',
  },
  title: {
    fontFamily: 'Inter',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '28px',
  },
  content: {
    padding: '0px',
  },
  contentTextRoot: {
    color: '#202223',
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '24px',
  },
  buttonStyles: {
    bottom: 0,
    position: 'sticky',
    height: 48,
    fontSize: '16px',
    fontFamily: 'Inter',
    fontWeight: 600,
    lineHeight: '24px',
    borderRadius: 4,
    textTransform: 'inherit',
    '&:hover': {
      boxShadow: 'none',
    },
    width: '100%',
    padding: '12px 16px',
  },
  dialogActionRoot: {
    padding: '0px 16px 0px 16px',
  },
  checkBoxTypography: {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '20px',
    color: '#202223',
  },
  displayFlex: {
    display: 'flex',
  },
  checkboxDialogContentRoot: {
    padding: '0px 16px 24px 16px',
  },
}));
